export function init([$row, $scroller]) {
  return {
    call: () => {
      $scroller.appendChild($row.cloneNode(true))
      $scroller.appendChild($row.cloneNode(true))
      $scroller.appendChild($row.cloneNode(true))
      $scroller.appendChild($row.cloneNode(true))
    },
    reAttachListeners: true,
  }
}

export function autoScroll([pos, $rows, rowWidth]) {
  return () =>
    $rows.forEach($row => {
      $row.style.transform = `translateX(-${rowWidth + (pos % rowWidth)}px)`
    })
}

export function scrollLoop([rowWidth, scrollLeft, $scroller]) {
  return () => ($scroller.scrollLeft = rowWidth + (scrollLeft % rowWidth))
}

export function toggleScrollable([$element, isScrollable]) {
  return () => {
    if (isScrollable) {
      $element.classList.add('-scrollable')
      $element.classList.remove('-largeenough')
    } else {
      $element.classList.remove('-scrollable')
      $element.classList.add('-largeenough')
    }
  }
}

export function resetScroll([$rows, $scroller]) {
  return () => {
    $rows.forEach($row => {
      $row.style.transform = `translateX(0px)`
    })
    $scroller.scrollLeft = 0
  }
}

export default {
  init,
  autoScroll,
  scrollLoop,
  toggleScrollable,
  resetScroll,
}



// WEBPACK FOOTER //
// ./rowSlider/actions.js